<script>
    import { onMount } from "svelte"
    import Modal from "./modal.svelte"

    const {
        options,
        dialog,
    } = $props()

    let open = $state(false)

    onMount(() => open = true)

    const {
        tIn,
        tOut,
        close,
        ws = "",
        persistent,
        ...opts
    } = options
    const dialogClose = (value) => {
        open = false
        setTimeout(
            () => close(value),
            tOut.duration
        )
    }
    const onClose = () => dialogClose(null)
</script>

<Modal bind:open inTime={0} outTime={tOut.duration} {onClose} {persistent}>
    <ws-dialog in:tIn.func={tIn} out:tOut.func={tOut} data-ws={ws} tabindex="-1">
        {@render dialog({ ...opts, close: dialogClose })}
    </ws-dialog>
</Modal>
